import React from "react";
import { useExemptionsContext } from "../../ExemptionsContext";
import ButtonV2 from "elements/ButtonV2";

export const ILOnHoldDisclaimer = () => {
	const { next } = useExemptionsContext();

	const handleSubmit = async () => {
		next();
	};

	return (
		<form
			onSubmit={e => {
				e.preventDefault();
				handleSubmit();
			}}>
			<div className="property-profile-question-card exemption-survey-card">
				<div className="property-profile-question-card-title-container">
					<p>
						<strong>Pleae confirm you understand,</strong> the window to file
						your exemption is currently closed and will reopen typically around
						March and April. We will prepare your exemption and then put your
						applcation on hold until the right time. While there won't be any
						uupdates during the on hold period, we'll reach out if we need
						anything else from you and will notify you once we have filed!
					</p>
				</div>
			</div>

			<ButtonV2 size="large" type="submit">
				I Understand
			</ButtonV2>
		</form>
	);
};
